import { render, staticRenderFns } from "./tvCatalog.vue?vue&type=template&id=408835cd&"
import script from "./tvCatalog.vue?vue&type=script&lang=js&"
export * from "./tvCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports